import React from 'react';

import { ExcludeDurationOption } from '@recurrency/core-api-schema/dist/common/enums';
import { TenantSettingKey } from '@recurrency/core-api-schema/dist/common/tenantSettings';

import { getTenantSetting } from 'utils/tenantSettings';

import { ISODateStr } from 'types/hash-state';

import { ExcludeDurationSelector } from './ExcludeDurationSelector';
import { IncludeExcludeDescription } from './IncludeExcludeDescription';
import { ItemLocationSettingChangeModal } from './ItemLocationSettingChangeModal';
import { getIsoDateForExcludeDurationOption, MultiModalSelection } from './utils';

export function IncludeExcludeModal({
  selection,
  exclude,
  onClose,
}: {
  selection: MultiModalSelection;
  exclude: boolean;
  onClose: (confirmData?: { excludedUntil?: ISODateStr }) => void;
}) {
  const defaultDuration =
    getTenantSetting(TenantSettingKey.FormExcludeDefaultDuration) ?? ExcludeDurationOption.OneMonth;
  const [selectedDuration, setSelectedDuration] = React.useState<ExcludeDurationOption>(defaultDuration);
  const [customDate, setCustomDate] = React.useState<ISODateStr | undefined>(undefined);

  const excludedUntil =
    selectedDuration === ExcludeDurationOption.Custom
      ? customDate
      : getIsoDateForExcludeDurationOption(selectedDuration);

  return (
    <ItemLocationSettingChangeModal
      selection={selection}
      set={exclude}
      bulkUpdateType={{ type: 'includeExclude', exclude }}
      description={<IncludeExcludeDescription exclude={exclude} excludedUntil={excludedUntil} />}
      customization={
        exclude ? (
          <ExcludeDurationSelector
            selectedDuration={selectedDuration}
            setSelectedDuration={setSelectedDuration}
            customDate={customDate}
            setCustomDate={setCustomDate}
          />
        ) : (
          <></>
        )
      }
      onSubmit={() => onClose({ excludedUntil: excludedUntil || undefined })}
      onClose={() => onClose()}
    />
  );
}
